import React, { useRef, useEffect } from 'react';
import Chart from 'chart.js/auto';

const BarChart = ({ data }) => {
  const canvasRef = useRef(null);
  const chartRef = useRef(null);

  useEffect(() => {
    if (!Array.isArray(data) || data.length === 0) return;

    const ctx = canvasRef.current.getContext('2d');

    // Destroy previous chart if it exists
    if (chartRef.current) {
      chartRef.current.destroy();
    }

    chartRef.current = new Chart(ctx, {
      type: 'bar',
      data: {
        labels: data.map((item) => `Week ${item.week_number}`),
        datasets: [
          {
            label: 'Total Makes',
            data: data.map((item) => item.total_makes),
            backgroundColor: '#1976d2'
          },
          {
            label: 'Total Attempts',
            data: data.map((item) => item.total_attempts),
            backgroundColor: '#90caf9'
          }
        ]
      },
      options: {
        responsive: true,
        maintainAspectRatio: false, // 🔧 Add this
        plugins: {
          legend: { position: 'top' },
          tooltip: { mode: 'index', intersect: false }
        },
        scales: {
          y: {
            beginAtZero: true,
            ticks: {
              precision: 0
            }
          }
        }
      }
    });
  }, [data]);

  return (
    <div style={{ width: '100%', maxWidth: '600px', height: '300px', margin: '0 auto' }}>
      {(!Array.isArray(data) || data.length === 0) ? (
        <p>No chart data available.</p>
      ) : (
        <canvas ref={canvasRef} />
      )}
    </div>
  );
};

export default BarChart;




